// extracted by mini-css-extract-plugin
export var lg = "_fa-7";
export var md = "_fa-6";
export var placeholderContainer = "_fa-1";
export var placeholderIcon = "_fa-2";
export var productImage = "_fa-0";
export var sm = "_fa-5";
export var xl = "_fa-8";
export var xs = "_fa-4";
export var xxs = "_fa-3";